import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
import React from "react";
import IconButton from "../../../../IconButton";
import { jsx as _jsx } from "react/jsx-runtime";
function IconButtonCell(_ref) {
  var size = _ref.size,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconButton, _extends({}, restProps, {
    size: "compact"
  }));
}
IconButtonCell.displayName = "IconButtonCell";
export default IconButtonCell;